import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Package } from 'src/app/core/models/package';

@Component({
  selector: 'app-package-selection',
  templateUrl: './package-selection.component.html',
  styleUrls: ['./package-selection.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ]
})
export class PackageSelectionComponent {
  @Input() packages: Package[] = [];
  @Input() selectedPackages: Package[] = [];
  @Input() companiesCount: number = 0;
  @Input() selectedEntityTypes: ('COMPANY' | 'INDIVIDUAL' | 'VESSEL')[] = [];

  @Output() packageToggled = new EventEmitter<Package>();

  togglePackage(pack: Package) {
    if (this.isPackageAvailable(pack)) {
      this.packageToggled.emit(pack);
    }
  }

  isPackageSelected(pack: Package): boolean {
    return this.selectedPackages.some(p => p.code === pack.code);
  }

  isPackageAvailable(pack: Package): boolean {
    if (pack.available === false) {
      return false;
    }
    
    // Check if package supports any of the selected entity types
    if (this.selectedEntityTypes.length > 0) {
      return this.selectedEntityTypes.some(entityType => 
        pack.supportedEntityTypes.includes(entityType)
      );
    }
    
    return true;
  }

  get filteredPackages(): Package[] {
    return this.packages.filter(pack => this.isPackageAvailable(pack));
  }
} 